import { Box, Button, Grid, Typography } from '@forgeglobal/design-framework';
import { useStyles } from './style';

interface ResetCompleteProps {
  close: () => void;
}

const ResetComplete = ({ close }: ResetCompleteProps) => {
  const classes = useStyles();
  return (
    <>
      <Typography variant="h5" data-test-id="sub-title">
        Your request has been received.
      </Typography>
      <Box mt={3}>
        <Typography variant="body1" data-test-id="reset-successfully-text">
          You should receive an email with instructions to reset your password.
          You need to reset the password within 1 hour after receiving the
          email.
        </Typography>
      </Box>
      <Box mt={8}>
        <Grid container item justifyContent="center">
          <div className={classes.passwordResetButtonsGrid}>
            <Button
              size="medium"
              color="primary"
              onClick={close}
              data-test-id="go-to-signin-button">
              Go To Sign In
            </Button>
            <div className={classes.passwordResetButtons}></div>
            <Button
              size="medium"
              color="primary"
              href="https://forgetrust.com/"
              data-test-id="return-home-button">
              Return Home
            </Button>
          </div>
        </Grid>
      </Box>
    </>
  );
};

export default ResetComplete;
